import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IDeleteCollectionRequest } from './delete-collection-request';
import type { IDeleteCollectionResponse } from './delete-collection-response';
import { deleteCollectionResponseSchema } from './delete-collection-response';

export async function deleteCollectionApi({
  id,
}: IDeleteCollectionRequest): Promise<IValidatedResponse<IDeleteCollectionResponse>> {
  return deleteRequest<IDeleteCollectionResponse>({
    path: `/sys/collections/${id}`,
    schema: deleteCollectionResponseSchema,
  });
}
